import LinkCategory from './LinkCategory';

export default LinkCategory;
